import React from "react";
import { DatePicker } from "@material-ui/pickers";

export const RenderDatePicker = ({ classes, input, label, helperText, ...custom }) => {
  const [selectedDate, handleDateChange] = React.useState(new Date());

  return (
    <DatePicker
      clearable
      required
      inputProps={{ 'data-testid': 'date' }}
      views={["year", "month"]}
      format="MM/yy"
      value={selectedDate}
      onChange={handleDateChange}
      {...input}
      {...custom}
    />
  );
};
